module.exports = __webpack_public_path__ + "img/caret-right-fill.d5b24ce0.svg";